// Modal Components
import { AlertCircle, AlertTriangle, ExternalLink } from "lucide-react";
import { CloseOutlined } from "@mui/icons-material";

export const ModalDuplicidadeAbsoluta = ({ open, clientes, onClose }) => {
  if (!open) return null;

  return (
    <div className="novoCliente__modal-overlay" onClick={onClose}>
      <div
        className="novoCliente__modal-content novoCliente__modal-error"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="novoCliente__modal-header">
          <AlertCircle style={{ color: "#f44336", fontSize: "2rem" }} />
          <h2>Cliente já existe</h2>
          <CloseOutlined
            className="novoCliente__modal-close"
            onClick={onClose}
          />
        </div>

        <div className="novoCliente__modal-body">
          <p>Encontramos um cliente idêntico no sistema:</p>

          {clientes.map((cliente, index) => (
            <div key={index} className="novoCliente__cliente-encontrado">
              <div className="novoCliente__cliente-info">
                <strong>Nome:</strong> {cliente.nome} <br />
                <strong>Nome Fiscal:</strong> {cliente.nomeFiscal} <br />
                <strong>Contacto:</strong> {cliente.contacto} <br />
                <strong>NIF:</strong> {cliente.nif} <br />
                <strong>Motivo:</strong>{" "}
                {cliente.motivoDuplicidade === "nif_nome_fiscal"
                  ? "NIF e Nome Fiscal idênticos"
                  : cliente.motivoDuplicidade === "nome_contacto"
                  ? "Nome e Contacto idênticos"
                  : cliente.motivoDuplicidade}
              </div>

              <button
                className="novoCliente__link-button"
                onClick={() => window.open(`/clientes/${cliente.id}`, "_blank")}
              >
                <ExternalLink /> Ver ficha do cliente
              </button>
            </div>
          ))}
        </div>

        <div className="novoCliente__modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};

export const ModalDuplicidadeRelativa = ({
  open,
  clientes,
  onClose,
  onContinuar,
}) => {
  if (!open) return null;

  return (
    <div className="novoCliente__modal-overlay" onClick={onClose}>
      <div
        className="novoCliente__modal-content novoCliente__modal-warning"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="novoCliente__modal-header">
          <AlertTriangle style={{ color: "#ff9800", fontSize: "2rem" }} />
          <h2>Possível cliente duplicado</h2>
          <CloseOutlined
            className="novoCliente__modal-close"
            onClick={onClose}
          />
        </div>

        <div className="novoCliente__modal-body">
          <p>Encontramos cliente(s) similar(es) no sistema:</p>

          {clientes.map((cliente, index) => (
            <div key={index} className="novoCliente__cliente-encontrado">
              <div className="novoCliente__cliente-info">
                <strong>Nome:</strong> {cliente.nome} <br />
                <strong>Nome Fiscal:</strong> {cliente.nomeFiscal} <br />
                <strong>Contacto:</strong> {cliente.contacto} <br />
                <strong>NIF:</strong> {cliente.nif} <br />
                <strong>Motivo:</strong>{" "}
                {cliente.motivoDuplicidade === "apenas_nif"
                  ? "Apenas NIF igual"
                  : cliente.motivoDuplicidade === "nome_similar_contacto"
                  ? "Nome similar e contacto igual"
                  : cliente.motivoDuplicidade === "nome_similar_nif"
                  ? "Nome similar e NIF igual"
                  : cliente.motivoDuplicidade === "nome_contacto_similar"
                  ? "Nome igual e contacto similar"
                  : cliente.motivoDuplicidade}
              </div>

              <button
                className="novoCliente__link-button"
                onClick={() => window.open(`/clientes/${cliente.id}`, "_blank")}
              >
                <ExternalLink /> Ver ficha do cliente
              </button>
            </div>
          ))}

          <p style={{ marginTop: "1rem", fontWeight: "bold" }}>
            Deseja continuar mesmo assim?
          </p>
        </div>

        <div className="novoCliente__modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            Cancelar
          </button>
          <button className="blue-button" onClick={onContinuar}>
            Continuar mesmo assim
          </button>
        </div>
      </div>
    </div>
  );
};
